import dayjs from 'dayjs'
import { SentShipmentsType, ReceivedShipmentsType, SentShipmentItemType } from '~/dashboard/model/types'
import { Price } from '~/basket/model/utils/price'
import { ACTION } from './actions'

export type Config = {
  isReceiptDisplayEnabled: boolean
}

export type DashboardState = {
  config: Config
  isLoading: boolean
  sentShipments: SentShipmentsType
  receivedShipments: ReceivedShipmentsType
}

export const defaultConfig: Config = {
  isReceiptDisplayEnabled: false,
}

const initState: DashboardState = {
  config: defaultConfig,
  isLoading: false,
  sentShipments: [],
  receivedShipments: [],
}

// eslint-disable-next-line @typescript-eslint/default-param-last, @typescript-eslint/no-explicit-any
export const dashboardReducer = (state = initState, action: any) => {
  switch (action.type) {
    case ACTION.UPDATE_DASHBOARD_CONFIG:
      return {
        ...state,
        config: {
          ...state.config,
          ...action.payload.config,
        },
      }
    case ACTION.UPDATE_DASHBOARD_REQUESTED:
      return {
        ...state,
        isLoading: true,
        searchTerm: action.payload.searchTerm,
      }
    case ACTION.UPDATE_DASHBOARD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        sentShipments: action.payload.shipments,
      }
    default:
      return state
  }
}

export type Shipment = {
  id: string
  orderId: string
  name: string
  status: string | null
  price: Price
  barcode?: string | null
  printlessCode?: string | null
  postcode?: string | null
  date: string
}

export type Dashboard = {
  config: Config
  shipments: Shipment[]
}

const getDashboard = (state: DashboardState): Dashboard => {
  const getStatus = (shipment: SentShipmentItemType) => {
    if (!shipment.trackAndTrace) {
      return null
    }

    return shipment.trackAndTrace.lastCategory
  }
  return {
    config: state.config,
    shipments: state.sentShipments.map((shipment: SentShipmentItemType) => ({
      id: shipment.id,
      orderId: shipment.orderId,
      name:
        shipment.receiver.name.companyName ||
        [shipment.receiver.name.firstName, shipment.receiver.name.lastName].join(' '),
      status: getStatus(shipment),
      price: shipment.total,
      barcode: shipment.trackAndTrace && shipment.trackAndTrace.barcode,
      printlessCode: shipment.printlessCode,
      postcode: shipment.receiver.address.zipCode,
      date: shipment.timeCreated && dayjs(shipment.timeCreated).format('DD-MM-YYYY'),
    })),
  }
}

const isLoadingDashboard = (state: DashboardState): boolean => state.isLoading

export const dashboardSelectors = {
  getDashboard,
  isLoadingDashboard,
}
